import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
declare var bootstrap: any;

@Component({
  selector: 'app-share-button',
  standalone: false,
  templateUrl: './share-button.component.html',
  styleUrl: './share-button.component.scss',
})
export class ShareButtonComponent {
  currentUrl = window.location.href;

  private readonly translate = inject(TranslateService);
  private readonly toastr = inject(ToastrService);

  openModal(event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const modalEl = document.getElementById('shareModal');

    if (modalEl) {
      document.body.appendChild(modalEl);

      const modal = new bootstrap.Modal(modalEl);
      modal.show();
    }
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      this.toastr.success(this.translate.instant('LINK_COPIED'));
    });
  }

  shareByEmail() {
    const subject = encodeURIComponent(this.translate.instant('SHARE_HEADER'));
    const body = encodeURIComponent(`${this.translate.instant('SHARE_LINK')} ${this.currentUrl}`);
    window.location.href = `mailto:info@bazar-s.com?subject=${subject}&body=${body}`;
  }

  shareByWhatsApp() {
    const message = encodeURIComponent(
      `${this.translate.instant('SHARE_HEADER')}: ${this.currentUrl}`
    );
    window.open(`https://wa.me/?text=${message}`, '_blank');
  }
}
